import { Pair } from 'bitecs';
import {
  setTraits,
  Sequence,
  SequenceState,
  Tween,
  TweenState,
  ChildOf,
  type State,
  type System,
  type Plugin,
} from '@multiplekex/shallot';

export const StepController = {
  step: [] as number[],
  target: [] as number[],
  max: [] as number[],
};

setTraits(StepController, {
  defaults: () => ({ step: 0, target: 0, max: 0 }),
});

export const StepTransition = {
  from: [] as number[],
  to: [] as number[],
};

setTraits(StepTransition, {
  defaults: () => ({ from: 0, to: 0 }),
});

export const TokenIndex = {
  index: [] as number[],
  group: [] as number[],
};

setTraits(TokenIndex, {
  defaults: () => ({ index: 0, group: 0 }),
});

function createStepControllerSystem(): System {
  let isTransitioning = false;

  return {
    group: 'simulation',
    update(state: State) {
      if (isTransitioning) return;

      for (const eid of state.query([StepController])) {
        const current = StepController.step[eid];
        const target = StepController.target[eid];

        if (current !== target) {
          isTransitioning = true;

          for (const seqEid of state.query([Sequence])) {
            if (Sequence.state[seqEid] === SequenceState.PLAYING) {
              Sequence.state[seqEid] = SequenceState.COMPLETE;
            }
          }

          state.step(0);

          for (const seqEid of state.query([Sequence])) {
            Sequence.state[seqEid] = SequenceState.IDLE;
            Sequence.elapsed[seqEid] = 0;
            for (const childEid of state.query([Pair(ChildOf.relation, seqEid), Tween])) {
              Tween.state[childEid] = TweenState.IDLE;
              Tween.elapsed[childEid] = 0;
            }
          }

          for (const seqEid of state.query([Sequence, StepTransition])) {
            if (StepTransition.from[seqEid] === current && StepTransition.to[seqEid] === target) {
              Sequence.state[seqEid] = SequenceState.PLAYING;
              break;
            }
          }

          StepController.step[eid] = target;
          isTransitioning = false;
        }
      }
    },
  };
}

export function createStepPlugin(): Plugin {
  return {
    components: { StepController, StepTransition, TokenIndex },
    systems: [createStepControllerSystem()],
  };
}
